import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
export default function Contact() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send a POST request to the backend
    axios
      .post(`${baseURL}/contact-message`, JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // Clear form inputs
        setData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });

        alert("Message sent successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error Sending Email:", error.message);
      });
  };
  return (
    <div>
      <Box sx={{ m: 1, width: "100%", textAlign: "center" }}>
        {" "}
        <h1>Contact Us</h1>
        <p>
          Have a question or need assistance? The Vintage Collective is always
          happy to help.
          <br />
          Email: thevintagecollectivesite@gmail.com
          <br />
          Facebook:{" "}
          <a
            href=" https://www.facebook.com/thevintagecollectiveph"
            target="_blank"
            rel="noopener noreferrer"
          >
            The Vintage Collective
          </a>
          <br />
          Instagram:{" "}
          <a
            href="https://www.instagram.com/the_vintage_collective/"
            target="_blank"
            rel="noopener noreferrer"
          >
            @the_vintage_collective
          </a>
          <br />
          Tiktok:{" "}
          <a
            href="https://www.tiktok.com/@thevintagecollectiveph"
            target="_blank"
            rel="noopener noreferrer"
          >
            thevintagecollectiveph
          </a>
        </p>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "60ch",
          }}
        >
          {" "}
          <Box
            component="form"
            sx={{ "& .MuiTextField-root": { m: 1, width: "100%" } }}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Box
              sx={{
                width: "inherit",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <TextField
                id="outlined-required"
                label="Name"
                value={data.name}
                onChange={(event) => {
                  setData({ ...data, name: event.target.value });
                }}
              />
              <TextField
                required
                id="outlined-required"
                label="Email"
                value={data.email}
                onChange={(event) => {
                  setData({ ...data, email: event.target.value });
                }}
              />
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                required
                id="outlined-required"
                label="Subject"
                value={data.subject}
                onChange={(event) => {
                  setData({ ...data, subject: event.target.value });
                }}
              />
              <TextField
                id="outlined-multiline-static"
                label="Message"
                multiline
                rows={4}
                fullWidth
                required
                value={data.message}
                onChange={(event) => {
                  setData({ ...data, message: event.target.value });
                }}
              />
            </Box>
            <Button variant="contained" type="Submit">
              Send
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
